export default function Footer() {
  return (
    <footer className="bg-[#0F1F17] text-white py-20 px-6">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid md:grid-cols-4 gap-12 mb-20">
          <div>
            <img 
              src="https://static.readdy.ai/image/2b7b3ddf793f3c719c327adf3690ce51/63eb944a0221ff0e07f66c21e4e2f04f.png" 
              alt="Logo" 
              className="h-12 w-auto mb-5 brightness-0 invert"
            />
            <p className="text-sm text-gray-400 leading-relaxed">
              Formación profesional en entrenamiento basada en evidencia científica y experiencia práctica.
            </p>
          </div>

          <div>
            <h3 className="text-[13px] text-gray-400 tracking-[0.15em] uppercase mb-5">
              Newsletter
            </h3>
            <div className="relative">
              <input
                type="email"
                placeholder="Tu email"
                className="w-full bg-transparent border-b border-gray-500 text-white placeholder-gray-500 py-3 pr-10 focus:outline-none focus:border-[#39FF14] transition-colors"
              />
              <button className="absolute right-0 top-1/2 -translate-y-1/2 cursor-pointer">
                <i className="ri-arrow-right-line text-gray-400 hover:text-[#39FF14] transition-colors text-xl"></i>
              </button>
            </div>
            <p className="text-xs text-gray-500 mt-3">
              Al suscribirte aceptas nuestra{' '}
              <a href="#" className="underline hover:text-[#39FF14] cursor-pointer">
                política de privacidad
              </a>
            </p>
          </div>

          <div>
            <h3 className="text-[13px] text-gray-400 tracking-[0.15em] uppercase mb-5">
              Recursos
            </h3>
            <ul className="space-y-4">
              <li>
                <a href="#modulos" className="text-[15px] text-gray-300 hover:text-[#39FF14] transition-colors cursor-pointer">
                  Programa Completo
                </a>
              </li>
              <li>
                <a href="#metodologia" className="text-[15px] text-gray-300 hover:text-[#39FF14] transition-colors cursor-pointer">
                  Metodología
                </a>
              </li>
              <li>
                <a href="#" className="text-[15px] text-gray-300 hover:text-[#39FF14] transition-colors cursor-pointer">
                  Preguntas Frecuentes
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-[13px] text-gray-400 tracking-[0.15em] uppercase mb-5">
              Contacto
            </h3>
            <ul className="space-y-4">
              <li>
                <a href="#" className="text-[15px] text-gray-300 hover:text-[#39FF14] transition-colors cursor-pointer">
                  Instagram
                </a>
              </li>
              <li>
                <a href="#" className="text-[15px] text-gray-300 hover:text-[#39FF14] transition-colors cursor-pointer">
                  YouTube
                </a>
              </li>
              <li>
                <a href="#" className="text-[15px] text-gray-300 hover:text-[#39FF14] transition-colors cursor-pointer">
                  Email
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-12">
          <h2 className="text-[80px] md:text-[120px] font-extrabold text-[#E8DCC4] tracking-tight leading-none text-center">
            ENTRENAMIENTO INTELIGENTE
          </h2>
          <div className="text-center mt-8">
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-gray-500 hover:text-[#39FF14] transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
